<div class="auth-container">
  <div class="auth-message-title">{{ authMessageTitle }}</div>
</div>
